"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const fi_1 = require("react-icons/fi");
const ActionFooter = ({ onDiscard, onSave }) => {
    return (react_1.default.createElement(material_1.Box, { sx: {
            backgroundColor: "white",
            padding: "12px 0",
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
        } },
        react_1.default.createElement(material_1.Container, { maxWidth: "lg", sx: { display: "flex", justifyContent: "flex-end" } },
            react_1.default.createElement(material_1.Stack, { direction: "row", spacing: "12px" },
                react_1.default.createElement(material_1.Button, { startIcon: react_1.default.createElement(fi_1.FiX, null), onClick: onDiscard, variant: "outlined", type: "reset" }, "Discard changes"),
                react_1.default.createElement(material_1.Button, { endIcon: react_1.default.createElement(fi_1.FiCheck, null), onClick: onSave, type: "submit", variant: "contained" }, "Save changes")))));
};
exports.default = ActionFooter;
